export default __webpack_public_path__ + "static/media/google.7d728ff0.png";